import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreService } from '../../core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { SystemUserTypes } from 'shared-library';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {

  session_info: SessionInfo

  constructor(
    private router: Router,
    public title_service: Title,
    private coreService: CoreService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.coreService.isLoggedIn()) {
      this.coreService.logMeOut()
      return false
    }

    this.session_info = this.coreService.getSessionInfo()
    if (this.session_info.user_details.user_category !== SystemUserTypes.ADMIN) {
      this.router.navigateByUrl("/404");
      return false
    }

    let roles = next.data.roles as Array<string>;
    if (roles && roles.length && this.session_info.user_details.current_organization_details.current_team_details.roles.indexOf("*") === -1) {
      let strict_all_roles = next.data.strict_all_roles || false
      let at_least_one_found = roles.filter(r => this.coreService.hasPermission(r)).length
      let all_found = at_least_one_found === roles.length
      if ((strict_all_roles && !all_found) || (!strict_all_roles && !at_least_one_found)) {
        this.router.navigateByUrl("/403");
        return false
      }
    }

    const page_titles: Array<string> = []
    if (next.data.page_title) {
      page_titles.push(next.data.page_title)
    }
    this.title_service.setTitle(page_titles.join(" | "));

    return true;
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.coreService.isLoggedIn()) {
      this.coreService.logMeOut()
      return false
    }

    this.session_info = this.coreService.getSessionInfo()
    if (this.session_info.user_details.user_category !== SystemUserTypes.USER) {
      this.router.navigateByUrl("/403");
      return false
    }

    const roles = next.data.roles as string[]
    if (roles?.length && this.session_info.user_details.current_organization_details.current_team_details.roles.indexOf("*") === -1) {
      let strict_all_roles = next.data.strict_all_roles || false
      let at_least_one_found = roles.filter(r => this.coreService.hasPermission(r)).length
      let all_found = at_least_one_found === roles.length
      if ((strict_all_roles && !all_found) || (!strict_all_roles && !at_least_one_found)) {
        this.router.navigateByUrl("/403");
        return false
      }
    }

    const page_titles: Array<string> = []
    if (next.data.page_title) {
      page_titles.push(next.data.page_title)
    }
    this.title_service.setTitle(page_titles.join(" | "));

    return true;
  }

}
